import React from "react";
import { Breadcrumb } from "antd";
import { Link } from "react-router-dom";
import useBreadcrumbItems from "./useBreadcrumbItems";

const currentStyle = {
  color: "#003A6C",
  fontWeight: 600,
  textDecoration: "underline",
  textUnderlineOffset: 4,
};

export default function BreadcrumbTrail({ style }) {
  const items = useBreadcrumbItems();

  if (!items.length) return null;

  return (
    <Breadcrumb
      style={{ marginBottom: 16, color: "rgba(0, 0, 0, 0.65)", ...style }}
      items={items.map((item) => ({
        title: item.to && !item.current ? (
          <Link to={item.to} state={item.state}>
            {item.label}
          </Link>
        ) : (
          <span style={item.current ? currentStyle : undefined}>{item.label}</span>
        ),
      }))}
    />
  );
}
